import { useState, useRef } from 'react';
import config from '../../config/apiConfig.json';

const useApi = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const inProgress = useRef(new Set()); // Track ongoing API calls
  const objectId = localStorage.getItem("objectId");

  const callApiFunction = async (apiName, payload) => {
    if (inProgress.current.has(apiName)) {
      console.warn(`API call for ${apiName} is already in progress.`);
      return; // Prevent duplicate execution
    }

    
    setLoading(true);
    setError(null);
    inProgress.current.add(apiName); // Mark API call as in progress

    const apiConfig = config.apis[apiName];
    if (!apiConfig) {
      inProgress.current.delete(apiName); // Cleanup on error
      throw new Error(`API configuration for ${apiName} not found`);
    }

    let { endpoint, method, headers } = apiConfig;
    let url = `${process.env.REACT_APP_BACKEND_URL}/${endpoint}`;
    const apiKey = process.env.REACT_APP_API_KEY;
    headers['x-api-key'] = apiKey;

    if (objectId) {
      headers['Authorization'] = `Bearer ${objectId}`;
    }

    if (payload) {
      for (const [key, value] of Object.entries(payload)) {
        if (url.includes(`#${key}`)) {
          url = url.replace(`#${key}`, `${key}=${value}`);
        }
      }
    }

    if (method === 'DELETE' && payload?.id) {
      url += `/${payload.id}`;
    }
    if (method === 'GET' && payload?.id) {
      url += `/${payload.id}`;
    }

    try {
      const response = await fetch(url, {
        method,
        headers,
        body: method !== 'GET' && method !== 'DELETE' ? JSON.stringify(payload) : null,
      });

      if (!response.ok) {
        throw new Error(`API call failed with status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      inProgress.current.delete(apiName); // Remove from in-progress set
      setLoading(false);
    }
  };

  return { callApiFunction, loading, error };
};

export default useApi;
